// initial state
import config from './config'
import analysis from './analysis'
import auth from './auth'
import site from './site'
import upload from './upload'
import user from './user'
import log from './log'
import cases from './cases'
import skill from './skill'
import show from './show'
import usertag from './usertag'
import regard from './regard'


// api 集合
const types = {}
Object.assign(types, config, analysis, auth, site,log,  upload, user, cases,skill,show,usertag,regard)
export default types
